var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 123 142"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#marker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.849 127.029S30.436 94.437 28.364 85.646c-4.996-21.206-5.913-36.459-2.722-45.334C33.467 18.55 57.532 7.214 79.294 15.04a41.6 41.6 0 0 1 14.022 8.439c15.048 10.607 21.198 30.011 14.946 47.397-3.146 8.751-13.822 19.882-32.636 34.024-13.209 9.933-25.438 17.563-25.955 17.883l-6.816 4.243zm31.487-98.202c-14.156-5.09-29.81 2.283-34.9 16.44-1.004 2.79-2.705 11.988 3.197 37.016a284 284 0 0 0 5.183 18.946c.604 1.934 1.06 3.35 1.41 4.379 4.686-3.121 11.11-7.536 17.678-12.48 22.008-16.556 26.613-24.543 27.571-27.21 4.06-11.287-.01-23.9-9.894-30.668l-.46-.317-.406-.38a27 27 0 0 0-9.374-5.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.364 68.396c-6.296 17.511-55.566 48.168-55.566 48.168s-.873-1.738-2.083-4.756c-4.669-14.76-10.584-52.811-5.766-66.21 6.297-17.51 25.594-26.6 43.105-20.304s26.601 25.594 20.304 43.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.473,
    d: "M96.81 65.897c-6.297 17.511-50.979 46.003-52.19 45.568-.692-.249-17.515-50.858-11.219-68.369 6.297-17.51 25.594-26.6 43.1-20.305 17.507 6.294 26.601 25.594 20.304 43.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B4FA",
    d: "M60.663 66.836c8.142 2.928 17.117-1.3 20.045-9.442s-1.3-17.117-9.442-20.045c-8.143-2.928-17.117 1.3-20.045 9.442-2.928 8.143 1.3 17.117 9.442 20.045"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.473,
    d: "M60.637 66.91c8.183 2.943 17.202-1.306 20.145-9.49 2.943-8.183-1.306-17.202-9.49-20.145-8.183-2.942-17.202 1.306-20.144 9.49-2.943 8.183 1.305 17.202 9.489 20.145"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "marker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m39.832.85 82.888 29.805-39.832 110.771L0 111.621z"
  })))));
};
export default SvgMarker;